<template>
  <div>
    <WechatBar v-if="visithost != 'smaco2.uestc.edu.cn'" />
    <v-app style="background: #fafafa;">
      <v-container justify-center>
        <v-layout justify-center column v-if="!loading">
          <v-card class="pa-2">
            <v-layout justify-center column>
              <div style="text-align: center;">
                <h2 style="font-size: 21px;">行人二维码</h2>
              </div>
              <div style="text-align: center" class="mt-2">
                <img
                  :src="'https://smaco2.uestc.edu.cn/qrcode' + codeInfo.picPath"
                  style="width:200px;height:200px"
                />
              </div>
              <div style="text-align: center; font-size: 14px;">
                二维码剩余有效时间{{ codeInfo.ttl }}秒
              </div>
            </v-layout>
            <v-layout justify-center>
              <v-btn class="primary" to="/info" tile>查看通行规则</v-btn>
            </v-layout>
          </v-card>
        </v-layout>
        <v-layout align-center class="pt-4" column style="height: 200px" v-else>
          <v-progress-circular
            :color="!failed ? 'accent' : 'error'"
            :value="100"
            size="50"
            indeterminate
          ></v-progress-circular>
          <v-card-title v-if="failed">登录失败</v-card-title>
          <v-btn to="/" v-if="failed" color="primary">返回</v-btn>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import WechatBar from "@/components/WechatBar";

export default {
  components: { WechatBar },
  data: () => ({
    loading: true,
    failed: false,
    codeInfo: null,
    visithost: location.host,
  }),
  mounted() {
    this.failed = false;
    this.$ajax
      .post(
        this.$store.state.uMode
          ? "https://smaco2.uestc.edu.cn/shiroApi/auth/thirdpart/login?pipe=uestc-portal"
          : "https://smaco2.uestc.edu.cn/shiroApi/auth",
        {
          username: this.$store.state.uID,
          password: this.$store.state.uPass,
          verifyKey: "",
        }
      )
      .then((resp) => {
        if (resp.data.status === 0) {
          this.failed = true;
        } else
          this.$ajax
            .get("https://passport-api.nia.ac.cn/pipe/pass/getObjectQrcode", {
              headers: {
                authorization: resp.data.data.Authorization,
              },
            })
            .then((response) => {
              this.codeInfo = response.data.data;
              this.loading = false;
            });
      });
  },
};
</script>

<style scoped>
.v-btn {
  margin: 6px 8px;
}
.container {
  padding: 16px;
}
</style>
